import { Entity, useLoadedEntities } from '@/pinia/loadedEntities'
import { storeToRefs } from 'pinia'

export function useEntityLookup() {
  const { loadedEntities } = storeToRefs(useLoadedEntities())
  function generateSpaceSuffix(entity: Entity): string {
    if (!entity?.properties) return ''
    const { nameTenant, labelTenant } = entity.properties
    if (nameTenant && labelTenant) {
      return ` (${labelTenant} ${nameTenant})`
    } else if (nameTenant) {
      return ` (${nameTenant})`
    } else if (labelTenant) {
      return ` (${labelTenant})`
    }
    return ''
  }
  const findEntity = (id: string) => {
    return loadedEntities.value.find((entity) => entity.id === id)
  }

  function getEntityDisplayStringFromPath(path: string | null): string | null {
    const id = path?.split('.').pop() ?? null
    return getEntityDisplayString(id)
  }

  function getEntityDisplayString(id: string | null, showSuffix: boolean = false): string | null {
    if (!id) {
      return null
    }

    const entity = findEntity(id)
    const baseName = entity?.name ?? id

    let spaceSuffix = ''
    if (entity?.type === 'SPACE' && showSuffix && entity.properties) {
      spaceSuffix = generateSpaceSuffix(entity)
    }

    let parentPrefix = ''
    if (entity?.type === 'LEVEL' && entity.parent?.name) {
      parentPrefix = `${entity.parent.name} - `
    }

    return `${parentPrefix}${baseName}${spaceSuffix}`
  }

  return {
    findEntity,
    getEntityDisplayString,
    getEntityDisplayStringFromPath
  }
}
